module.exports = __webpack_public_path__ + "static/enjoy-mathematics-cover-96c6cd601fff0b3539fd8cf0f3c033c3.svg";